var map = {
	"./Character.ts": 324,
	"./Character/amber.ts": 325,
	"./Character/hutao.ts": 326,
	"./Character/release.ts": 327,
	"./Test.ts": 328,
	"./ascension.ts": 329,
	"./common.ts": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 660;